<template>
  <div class="max_box">
    <div data-v-b8fb3c5c="" class="recent-games">
        

        <div data-v-b04cd74c="" class="head"><img data-v-b04cd74c=""
        src="/downloaded_images/ws1003quans3.wjbsails.com/ng/h5_static/img/logo_icon.8abe279d.png">
    <div data-v-b04cd74c="" class="head-text"> 会话 </div><img data-v-b04cd74c=""
        src="data:image/png;base64,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"
        alt="" class="right">
</div>


        <div data-v-9349a398="" class="PulldownRefresh">
            <div data-v-9349a398="" class="van-pull-refresh">
                <div class="van-pull-refresh__track" style="transition-duration: 0ms;">
                    <div class="van-pull-refresh__head" style="height: 80px;"></div>
                    <div data-v-9349a398="" class="main_content">
                        <div class="gameliostss">
                            <div class="gameliostssinner">
                                <div class="accounts-list">
                                  <div data-v-d56ea1b0="" class="gamebtn"  @click="$parent.goNav('/message')">
                                    <div class="accounts-swipe-cell"><img src="/static/img/laba.3dac2c89.png">
                                        <div class="accounts-list-right">
                                            <div class="nttitle">公告通知<img
                                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAC90lEQVRYR+2XPWgUURSFz5mJEQslaitikUpsLFJrCgsFZ9RCcGcVDUpAERXjL0Y0+BNUIkhEbVTIzppOZ1EEDbidVUA7kZhCbBQM+AOCuzNHZnSXWTO7O7sGbdxy59773fPmvvPeEH/wE0ACarcE2030cxsPEsYQqDIDnuB271artdqCl1yr1xQnQBi/gBJw1HS8K6000DJcdzZ1qTN4CXD5byCROMmMN5y2gZbhvmu7BDL1AIQG6RTOpWkgEV7OWX0GeRnAkjRFUsTMkBhgxrsTj02EB679cQ7BFd6M4XhL08Db3j6NVsFwvBqx9ZT/h6eYpfQhbS07gXV0vIkQE+TsZyDWJiKFopH1esNnpTFrnWnwSTyuITw0kKBT1xP28SQdryf0ceU3rpGMYhLcD/zeedsfFiVQeWsS4Op4nKScgdI+Zh9/Dv+vDpxcq1fA3QTnivIJbaNTGK+rPqZaruUIzCU1SGgaNLPM3H8eweVaBySOxLx6Vh6BKXx9t5L9k6Uk9VXV19bP19LOVwBW1J8GlQntYXgsKmd/ArGw2egI2m86hdFZ6mtU24cEjDSrBeltpDxwrRmAi5smAO8571M3txa/xtVXVUeHjqYA1DhZcl1N/1z2MbtfBm7EZ6DBwXGGTuFsVT2AyoT7rj1M4FgKEUEAObGBswcEXErRwBf637q548mHUH3ZF6MJz21ZJvqvASxoDJco7GW2cLPGXpW3j0u42KxzQaOmU9gfj/Nd+zaBXU1yReAwHe9qzVarJMm1BgUONSnynSWu5M4Hb6LXNr55lfzgBQCzUZ6EU2bWO1+JaftgkXTPzBaiS0Xg2o8AbGi2Ym3Za52iAQO/Bx0dixToWTNw+Hwu4aHrPZXQBbLnr8PTAOMxaZX/u2uUclaf5vgCGUhHOrKF2/GVaOnqnGIbSsJgfDs1ejUtwaM9/dOILsx2Qolg1UDSzEPL8LCo79oDrLXigNK+0DLTQBuaTJoCytu7JZyGVI4+k35dNNLkVmJ+ALq9Z2aHJAYAAAAAAElFTkSuQmCC">
                                            </div><span class="rednum">1</span><br><span class="lastContent">
                                                从2026年3月1号开始，将进行流水福利的大升级。
                                                现改...</span>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <div class="accounts-scroll"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
  <script>
//
export default {
  name: 'Foot',
  data() {
    return {};
  },
  methods: {},
  mounted() {

  },
  watch: {},
};
</script>
  
<style lang="scss" scoped>
.recent-games {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #f3f3f6;
    position: fixed;
    top: 0;
    left: 0
}

.recent-games .gameliostss {
    width: 100%;
    height: calc(100% - 2.53333rem);
    scrollbar-width: none;
    -ms-overflow-style: none;
    overflow-x: hidden;
    overflow-y: scroll
}

.recent-games .gameliostss::-webkit-scrollbar {
    display: none;
    width: 0;
    background: transparent
}

.recent-games .gameliostss .gameliostssinner {
    width: 100%;
    padding-bottom: .26667rem;
    margin-bottom: 2.66667rem
}

.recent-games .accounts-scroll {
    width: 100%;
    overflow-x: scroll;
    overflow-y: scroll
}

.recent-games .accounts-list {
    border-bottom: .02667rem solid #e2e2e2;
    background: #fff;
    height: 1.86667rem
}

.recent-games .accounts-list,
.recent-games .accounts-list .van-swipe-cell,
.recent-games .accounts-list .van-swipe-cell__wrapper {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 100%
}

.recent-games .accounts-list .van-swipe-cell__right {
    height: 1.86667rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex
}

.recent-games .accounts-list .accounts-swipe-cell {
    height: 1.86667rem;
    width: 10rem
}

.recent-games .accounts-list .accounts-swipe-cell img {
    width: 1.06667rem;
    height: 1.06667rem;
    margin-top: .4rem;
    margin-right: .34667rem;
    margin-left: .4rem;
    float: left
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right {
    float: left;
    width: 8rem;
    margin: 0 0;
    font-size: .32rem;
    color: #424653;
    font-weight: 700;
    position: relative
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle {
    width: 100%;
    height: .64rem;
    line-height: .64rem;
    font-weight: 700;
    margin-top: .26667rem
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle,
.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle div {
    float: left;
    color: #424653;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: .37333rem
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle div {
    width: 50%;
    height: .37333rem
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle div:nth-child(2) {
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    font-size: .26667rem;
    color: #7e88ad;
    font-weight: 400
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .nttitle img {
    width: .4rem;
    height: .4rem;
    margin-left: .18667rem;
    margin-top: 0
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right span {
    font-size: .32rem;
    zoom: .84;
    color: #7e88ad;
    height: .32rem;
    margin-top: .16rem;
    font-weight: 500
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .lastContent {
    float: left;
    width: 90%;
    overflow: hidden;
    height: .66667rem;
    font-size: .34667rem;
    font-weight: 500;
    color: #7e88ad;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: .66667rem;
    text-align: left
}

.recent-games .accounts-list .accounts-swipe-cell .accounts-list-right .accounts-list-text02 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    width: 7.68rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis
}

.recent-games .delete-button,
.recent-games .van-button--danger {
    background-color: #ea4e3d;
    border: .02667rem solid #ea4e3d
}

.recent-games .delete-button {
    height: 100%
}

.recent-games .cancel-button {
    height: 100%;
    background-color: #c7c7cb;
    border: .02667rem solid #c7c7cb;
    color: #fff
}

.recent-games .rednum {
    float: right;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: .53333rem;
    height: .53333rem !important;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 50%;
    right: .26667rem;
    top: .4rem;
    background: #f81b1b;
    color: #fff !important;
    position: absolute
}


.recent-games .head[data-v-b04cd74c] {
    height: 1.17333rem;
    padding: 0 .26667rem;
    background: #fff;
    border-bottom: .02667rem solid #eceff6;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between
}

.recent-games .head img[data-v-b04cd74c] {
    height: .88rem;
    border-radius: .53333rem
}

.recent-games .head .head-text[data-v-b04cd74c] {
    font-size: .48rem;
    color: #1d2548;
    font-weight: 600
}

.recent-games .head .onlinepng[data-v-b04cd74c] {
    margin-left: 3.06667rem;
    width: .66667rem;
    height: .66667rem;
    margin-top: .26667rem
}

.recent-games .head .right[data-v-b04cd74c] {
    width: .64rem;
    height: .64rem;
    border-radius: 0
}
</style>
  